<template>
    <div class="quesPreview">
        <div class="topBox">
            <img class="top" :src="require('@/common/images/toolmgt/view-top.png')" alt="">
        </div>
        <div class="innerBox">
            <div class="coverImgBox" :style="'background:url('+ (item.coverurl?item.coverurl:bgQuesHeader) + '?' + time+') 100%;background-size: 100%;'">
                <div class="mask">
                    <div class="name">{{item.name}}</div>
                    <div class="desp">{{item.desp}}</div>
                </div>
            </div>
            <div class="container">
                <div class="box" v-for="(obj,index) in item.formlist" :key="index">
                    <div class="colname">{{obj.colname}}<span v-if="obj.isnotnull" class="tc-red">*</span></div>
                    <div class="innerbox text" v-if="[1,2,4].indexOf(obj.coltype)>-1">
                        <input type="text" :placeholder="obj.placeholder" />
                    </div>
                    <div class="innerbox date" v-if="[3,9].indexOf(obj.coltype)>-1">
                        <div class="flexbetween">
                            <input type="text" :placeholder="obj.placeholder" />
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                    <div class="innerbox textarea" v-if="[5].indexOf(obj.coltype)>-1">
                        <textarea name="" rows="3" :placeholder="obj.placeholder"></textarea>
                    </div>
                    <div class="innerbox radio" v-if="[6].indexOf(obj.coltype)>-1">
                        <el-radio-group>
                            <el-radio :label="obj2.value" v-for="(obj2,index2) in obj.optionsinfo" :key="index2"></el-radio>
                        </el-radio-group>
                    </div>
                    <div class="innerbox checkbox" v-if="[7].indexOf(obj.coltype)>-1">
                        <el-checkbox v-for="(obj2,index2) in obj.optionsinfo" :key="index2">{{obj2.value}}</el-checkbox>
                    </div>
                    <div class="innerbox checkbox" v-if="[8].indexOf(obj.coltype)>-1">
                        <div class="flexbetween">
                            <input type="text" :placeholder="obj.placeholder" />
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'quesPreview',
    props: ['item', 'time'],
    data() {
        return {
            bgQuesHeader: 'https://img.capwhale.com/kmc/commonform_cover_default.png',
        }
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.quesPreview {
    width: 320px;
    max-width: 320px;
    height: 534px;
    background: rgba(242, 246, 252, 1);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3);
    overflow-y: auto;
    overflow-x: hidden;
    .innerBox {
        width: 320px;
        height: 482px;
        overflow-y: scroll;
        position: relative;
        padding-bottom: 48px;
        box-sizing: border-box;
    }
    .topBox {
        height: 52px;
        .top {
            width: 300px;
            height: 52px;
        }
    }
    .coverImgBox {
        background: #DCDCDC;
        width: 300px;
        height: 168px;
        background-repeat: no-repeat !important;
        background-size: 300px 168px !important;
        position: relative;
        .mask{
            position: absolute;
            top:0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            text-align: center;
            .name{
                margin-top: 45px;
                font-size: 16px;
            }
            .desp{
                font-size: 12px;
                margin-top: 15px;
                padding:0 10px;
                line-height: 24px;
            }
        }
    }
    .container{
        padding: 0 20px 20px 20px;
        background: #fff;
        .box{
            border-bottom: 1px solid #EEEEEE;
            color: #999;
            font-size: 14px;
            .colname{
                color: #333;
                padding-top: 15px;
            }
            .innerbox{
                padding: 15px 0;
            }
            textarea{
                border-width: 0;
                resize: none;
                width: 100%;
            }
            input{
                border-width: 0;
            }
            .radio .el-radio-group,.checkbox{
                display: flex;
                flex-direction: column;
                .el-radio+.el-radio,.el-checkbox+.el-checkbox{
                    margin-top: 15px;
                }
            }
        }
    }
    .el-radio__label,.el-checkbox__label{
        line-height: 24px;
        display: inline-block;
        width: 240px;
        white-space: normal;
    }
    .el-radio__input,.el-checkbox__input{
        vertical-align: top;
        margin-top: 6px;
    }
}
</style>
